import { eachL, go, mapL, min } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
export const alignToTopEnd = (self, els) => {
  self._checkNoProcessingTask();
  const art_board = self._getArtBoardThrowable();
  const translate_transform = self._getTranslateTransformThrowable();
  const [el] = els;
  if (el != null && els.length <= 1) {
    const { y } = art_board.getBBoxInViewPort();
    translate_transform.translateSingleElAlignTo({
      el,
      align: "top",
      coordinate: y,
    });
    return;
  }
  const top_end_y = go(
    els,
    eachL((el) => self._transform_manipulator.initTransform(el)),
    mapL((el) => {
      const bbox = el.getBBox();
      const el_ctm = el.getCTM();
      if (el_ctm == null) {
        throw new Error(`엘리먼트의 CTM 을 구할 수 없습니다.`);
      }
      const fixed_transform = self._transform_manipulator.getFixedTransform(el);
      if (fixed_transform == null) {
        throw new Error(`엘리먼트의 fixed_transform 을 구할 수 없습니다.`);
      }
      const { matrix: fixed_transform_matrix } = fixed_transform;
      return go(
        [
          [bbox.x, bbox.y],
          [bbox.x + bbox.width, bbox.y],
          [bbox.x + bbox.width, bbox.y + bbox.height],
          [bbox.x, bbox.y + bbox.height],
        ],
        mapL(CommonNS.UtilNS.createSVGPoint(self._svg_el)),
        mapL((point) => point.matrixTransform(fixed_transform_matrix)),
        CommonNS.UtilNS.calculateMinMaxXY,
        ({ min_x, min_y, max_x, max_y }) => [
          [min_x, min_y],
          [max_x, min_y],
          [max_x, max_y],
          [min_x, max_y],
        ],
        mapL(CommonNS.UtilNS.createSVGPoint(self._svg_el)),
        mapL((point) =>
          point.matrixTransform(
            el_ctm.multiply(fixed_transform_matrix.inverse())
          )
        ),
        mapL(({ y }) => y),
        min
      );
    }),
    min
  );
  for (const el of els) {
    translate_transform.translateSingleElAlignTo({
      el,
      align: "top",
      coordinate: top_end_y,
    });
  }
};
